import { render } from "./GibergHome.vue?vue&type=template&id=067fe63f&scoped=true"
import script from "./GibergHome.vue?vue&type=script&lang=js"
export * from "./GibergHome.vue?vue&type=script&lang=js"

import "./GibergHome.vue?vue&type=style&index=0&id=067fe63f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067fe63f"]])

export default __exports__